import React, { useState, useContext, useEffect } from 'react';
import { Col, Row, FormGroup, Label, Input, Form } from 'reactstrap';
import Button from '../global/Button';
import axios from '../../api/axios';
import { GlobalContext } from '../../App';
import { toast } from 'react-toastify';
import SubHeader from './SubHeader';
import { useNavigate } from 'react-router-dom';
import TopHeader from './TopHeader';
import { BsChevronRight } from "react-icons/bs";
function SerialSequence() {
  const { rolexModuleData, user_id } = useContext(GlobalContext);
  const navigate = useNavigate();
  const [serialSequence, setSerialSequence] = useState([
    { prefix: '', projectSeqence: '', currentId: '', hours: '', minutes: '' },
  ]);

  const [serialSequenceData, setSerialSequenceData] = useState([]);

  //------------------------------------------------- Get Serial Sequence --------------------------------------------
  const getSerialSequence = () => {
    axios
      .get('/getSerialSequence')
      .then((response) => {
        const serialSequence = response?.data?.map((data) => ({
          sequenceType: data?.sequence_type,
          prefix: data?.prefix,
          projectSeqence: data?.project_seqence,
          updateId: data?.serial_sequence_id,
          currentId: data?.current_id,
          hours: data?.hours,
          minutes: data?.minutes,
        })) || [];
        localStorage?.setItem('serialSequence', btoa(JSON.stringify(response?.data)));
        setSerialSequence(serialSequence);
        setSerialSequenceData(response?.data);
      })
      .catch((error) => {
        const statusCode = error.response ? error.response.status : null;
        let errorMessage = '';
        if (statusCode === 500) {
          errorMessage = 'Internal Server Error';
        } else if (statusCode === 404) {
          errorMessage = 'Page Not Found';
        } else {
          errorMessage = 'No API Response';
        }
        toast.error(errorMessage, {
          position: toast.POSITION.TOP_RIGHT,
          theme: 'colored',
          autoClose: 2000,
        });
      });
  };

  //------------------------------------------------- Update Setup ----------------------------------------------------
  const handleChange = (index, field, value) => {
    setSerialSequence((prevState) => {
      const serialSequenceArr = [...prevState];
      const currentItem = { ...serialSequenceArr[index] };
      currentItem[field] = value;
      if (field === 'projectSeqence') {
        currentItem.currentId = `0`.padStart(value, '0');
      }
      serialSequenceArr[index] = currentItem;
      return serialSequenceArr;
    });
  };

  //------------------------------------------------- Update Serial Sequence ------------------------------------------
  const updateSerialSequence = (e) => {
    e.preventDefault();
    const isEmptyField = serialSequence.some((data) => !data.prefix || !data.projectSeqence || !data.currentId);
    if (isEmptyField) {
      toast.error('All fields are required!', {
        position: toast.POSITION.TOP_RIGHT,
        theme: 'colored',
        autoClose: 2000,
      });
      return;
    }
    const params = {
      serialSequence: serialSequence,
      user_id: user_id,
    };
    axios
      .post('/updateSerialSequence', params)
      .then(() => {
        toast.success('Serial sequence data is updated successfully!', {
          position: toast.POSITION.TOP_RIGHT,
          theme: 'colored',
          autoClose: 2000,
        });
        localStorage?.removeItem('serialSequence');
        getSerialSequence();
      })
      .catch((error) => {
        const statusCode = error.response ? error.response.status : null;
        let errorMessage = '';
        if (statusCode === 500) {
          errorMessage = 'Internal Server Error';
        } else if (statusCode === 404) {
          errorMessage = 'Page Not Found';
        } else {
          errorMessage = 'No API Response';
        }
        toast.error(`updateSerialSequence: ${errorMessage}`, {
          position: toast.POSITION.TOP_RIGHT,
          theme: 'colored',
          autoClose: 2000,
        });
      });
  };

    // ---------------------------------------------------------- Mantain Log History ------------------------------
const postLogHistory = () =>{
  const param = {
    user_id : user_id,
    module_name : 'Serial Sequence',
    operationPerformed : 'navigate to serial sequence screen',
  }
  axios.post('/postLogHistory',param);
}
  useEffect(() => {
    getSerialSequence();
    //postLogHistory();
  }, []);

  //------------------------------------------------- HTML Start -------------------------------------------------------
  return (
    <>
    <TopHeader
    breadCrumb = {
    <>
        <li className="nav-item"><a  onClick={() => navigate("/home")} className="nav-link">Home <BsChevronRight /></a></li> 
        <li className="nav-item"><span>Serial Sequences</span></li>
    </>
    }/>
      <SubHeader SubHeaderTitle="Serial Sequence" />
      <div id="#serialsequence" className="contentInnerWrap">
        <div className="serialsequence-wrap">
          {serialSequence.length > 0 ? (
            <>
              {serialSequence.map((data, index) => (
                <div className={data?.sequenceType} key={index}>
                  <Form>
                    <Row>
                      <h4>{data?.sequenceType}</h4>
                      {data?.sequenceType === 'Task Details' && (
                        <>
                          <Col md={6}>
                            <FormGroup>
                              <Label htmlFor="projectsequence">Timesheet Duration (Prior To Dates)*</Label>
                              <Input
                                id="projectsequence"
                                name="ProjectSequence"
                                type="number"
                                value={data?.projectSeqence}
                                onKeyPress={(e) => e.preventDefault()}
                                onChange={(e) => {
                                  const inputValue = e.target.value.replace(/\D/g, '').slice(0, 2);
                                  handleChange(index, 'projectSeqence', inputValue);
                                }}
                              />
                            </FormGroup>
                          </Col>
                          <Col md={6}>
                            <FormGroup>
                              <Label htmlFor="projectsequence">Log Hours Duration (Prior To time)*</Label>
                              <Row>
                                <Col md={2}>
                                  <FormGroup>
                                    <Label htmlFor="projectsequence">Hours*</Label>
                                  </FormGroup>
                                </Col>
                                <Col md={4}>
                                  <FormGroup>
                                    <Input
                                      id="projectsequence"
                                      name="ProjectSequence"
                                      type="number"
                                      value={data?.hours}
                                      min={0}
                                      max={23}
                                      onKeyPress={(e) => e.preventDefault()}
                                      onChange={(e) => {
                                        const inputValue = e.target.value.replace(/\D/g, '').slice(0, 2);
                                        handleChange(index, 'hours', inputValue);
                                      }}
                                    />
                                  </FormGroup>
                                </Col>
                                <Col md={2}>
                                  <FormGroup>
                                    <Label htmlFor="projectsequence">Minutes*</Label>
                                  </FormGroup>
                                </Col>
                                <Col md={4}>
                                  <FormGroup>
                                    <Input
                                      id="projectsequence"
                                      name="ProjectSequence"
                                      type="number"
                                      value={data?.minutes}
                                      onKeyPress={(e) => e.preventDefault()}
                                      min={0}
                                      max={59}
                                      onChange={(e) => {
                                        const inputValue = e.target.value.replace(/\D/g, '').slice(0, 2);
                                        handleChange(index, 'minutes', inputValue);
                                      }}
                                    />
                                  </FormGroup>
                                </Col>
                              </Row>
                            </FormGroup>
                          </Col>
                        </>
                      )}

                      {data?.sequenceType === 'User Timesheet Report' && (
                        <Col md={4}>
                          <FormGroup>
                            <Label htmlFor="ProjectSequence">Timesheet Report Duration (Prior To Dates)*</Label>
                            <Input
                              id="projectsequence"
                              name="ProjectSequence"
                              type="number"
                              value={data?.projectSeqence}
                              onKeyPress={(e) => e.preventDefault()}
                              onChange={(e) => {
                                const inputValue = e.target.value.replace(/\D/g, '').slice(0, 2);
                                handleChange(index, 'projectSeqence', inputValue);
                              }}
                            />
                          </FormGroup>
                        </Col>
                      )}

                      {data?.sequenceType !== 'Task Details' && data?.sequenceType !== 'User Timesheet Report' && (
                        <>
                          <Col md={4}>
                            <FormGroup>
                              <Label htmlFor="prefix">Prefix*</Label>
                              <Input
                                id="prefix"
                                name="Prefix"
                                type="text"
                                value={data?.prefix}
                                onChange={(e) => handleChange(index, 'prefix', e.target.value)}
                              />
                            </FormGroup>
                          </Col>
                          <Col md={4}>
                            <FormGroup>
                              <Label htmlFor="projectsequence">{data?.sequenceType} Sequence*</Label>
                              <Input
                                id="projectsequence"
                                name="ProjectSequence"
                                type="number"
                                value={data?.projectSeqence}
                                min={serialSequenceData[index]?.project_seqence}
                                max={9}
                                onKeyPress={(e) => e.preventDefault()}
                                onChange={(e) => handleChange(index, 'projectSeqence', e.target.value)}
                              />
                            </FormGroup>
                          </Col>
                          <Col md={4}>
                            <FormGroup>
                              <Label htmlFor="currentid">Current ID*</Label>
                              <Input id="currentid" name="CurrentId" type="number" value={data?.currentId} disabled />
                            </FormGroup>
                          </Col>
                        </>
                      )}
                    </Row>
                  </Form>
                </div>
              ))}
              <Button color="primary" type="button" className="btn" onClick={updateSerialSequence} style={{ marginLeft: '0', boxShadow: 'none', padding: '0' }}>
                Submit
              </Button>
            </>
          ) : (
            <p>There is no setup yet!</p>
          )}
        </div>
      </div>
      </>
  );
}

export default SerialSequence;
